import { HeaderCellProps } from '../types';

export const TenantTagsHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Tags</div>;
};
